'use strict';
(function () { 

    angular
        .module('invesfleet')
        .factory('httpInterceptor', httpInterceptor);
        
    httpInterceptor.$inject = ['$q', '$window', '$injector'];
    
    function httpInterceptor($q, $window, $injector){
        return {
            responseError: function(rejection) {
                if (rejection.status === 401) //Unauthorized
                {
                    var state = $injector.get('$state').current.name;
                    var token = $window.localStorage.getItem('bearerToken');

                    if (token || state !== 'login') {
                        $window.localStorage.removeItem('bearerToken');
                        $window.location = '/';
                    }
                }
                //else if (rejection.status === 404) {
                //}
                //console.log('rejection.status >> ' + rejection.status + ' <<');

                return $q.reject(rejection); 
            }
        };
    }
})();